import {AfterViewInit, Component, ElementRef, Input} from '@angular/core';
import {AppEnvironmentService} from 'src/app/infrastructure/environment/app-environment/app-environment.service';
import {WebComponent} from 'src/app/ui/webapp/component/web.component';

@Component({
  selector: 'app-share-screen',
  templateUrl: 'share-screen-component.html',
})
export class ShareScreenComponent extends WebComponent implements AfterViewInit {
  @Input() size: 'sm' | 'md' | 'xl' = 'md';
  public width: number;
  public height: number;

  constructor(
    private environment: AppEnvironmentService,
    private elementRef: ElementRef
  ) {
    super();
  };

  onInit(): void {
    switch (this.size) {
      case 'sm':
        this.width = 18;
        this.height = 18;
        break;
      case 'md':
        this.width = 30;
        this.height = 24;
        break;
      case 'xl':
        this.width = 50;
        this.height = 44;
        break;
      default:
    }
  }

  ngAfterViewInit(): void {
    const shareScreenConfiguration = this.environment.shareScreenConfiguration();

    const scriptTag = document.createElement('script');
    scriptTag.id = 'glance-cobrowse';
    scriptTag.setAttribute('data-groupid', shareScreenConfiguration.groupid);
    scriptTag.setAttribute('data-site', shareScreenConfiguration.site);
    scriptTag.type = 'text/javascript';
    scriptTag.src = 'https://www.glancecdn.net/cobrowse/CobrowseJS.ashx?' +
    'group=' + shareScreenConfiguration.groupid +
    '&site=' + shareScreenConfiguration.site;
    scriptTag.charset = 'UTF-8';
    this.elementRef.nativeElement.appendChild(scriptTag);
  }
}
